var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAv5InboxCheckWithBackground = function SvgAv5InboxCheckWithBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-variant": "icon-with-background"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "icon-background",
    r: 9,
    cx: 9,
    cy: 9,
    fill: "#ECF0FD",
    "data-no-stroke": "true"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "inner-vectors"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.5 6-5.538 6L5 9.5",
    stroke: "#8399C6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-no-fill": "true"
  }))));
};
export { SvgAv5InboxCheckWithBackground as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZGF0YS12YXJpYW50PSJpY29uLXdpdGgtYmFja2dyb3VuZCI+CiAgICA8Y2lyY2xlIGNsYXNzPSJpY29uLWJhY2tncm91bmQiIHI9IjkiIGN4PSI5IiBjeT0iOSIgZmlsbD0iI0VDRjBGRCIgZGF0YS1uby1zdHJva2U9InRydWUiLz4KICAgIDxnIGNsYXNzPSJpbm5lci12ZWN0b3JzIj4KICAgICAgICA8cGF0aCBkPSJNMTMuNSA2TDcuOTYxNTQgMTJMNSA5LjUiCiAgICAgICAgICAgICAgc3Ryb2tlPSIjODM5OUM2IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkYXRhLW5vLWZpbGw9InRydWUiLz4KICAgIDwvZz4KPC9zdmc+Cg==";